import * as React from "react";
import { Component } from "react";

interface PropsType {
  name: string;
  offValue: string;
  on: boolean;
  onChange?: (boolean) => void;
  onValue: string;
}

interface StateType {
  on: boolean;
}

export default class Switch extends Component<PropsType, StateType> {
  static defaultProps = {
    onChange: (): void => {},
  };

  constructor(props) {
    super(props);

    this.state = { on: props.on };
  }

  onChange = (): void => {
    const on = !this.state.on;

    this.setState({ on });
    this.props.onChange(on);
  };

  render(): JSX.Element {
    const { offValue, name, onValue } = this.props;
    const { on } = this.state;

    return (
      <div className="form--switch" {...{ name }}>
        <input defaultValue={offValue} hidden {...{ name }} />
        <input
          checked={on}
          readOnly
          type="checkbox"
          value={onValue}
          {...{ name }}
        />

        <div className="track">
          <button className="knob" onClick={this.onChange} type="button" />
        </div>
      </div>
    );
  }
}
